
          import "TabBar.styles_1bf7oz6.linaria.css";
          import { styled } from "@linaria/react";
const TabList = /*#__PURE__*/styled("div")({
  name: "TabList",
  class: "t1bkp3au"
});
export default TabList;
          